module.exports = "/_next/static/images/Daria_Gardas-d65f2eed52842b2ec82fac40acdd99fe.webp";